import React, { FC } from "react";
import styled from "styled-components";
import ApiStory from "models/data/api/ApiStory";
import ApiAuthor from "models/data/api/ApiAuthor";
import StoryTitle from "components/shared/text/StoryTitle";
import StoryAuthorName from "components/shared/text/StoryAuthorName";
import StoryAuthorsName from "components/shared/text/StoryAuthorsName";
import StoryDate from "components/shared/text/StoryDate";
import Time from "models/data/utils/Time";

const HeaderContainer = styled.div.attrs({
  className: "w-full flex flex-col items-center px-6 pt-6",
})``;

const Summary = styled.h2`
  text-align: center;
  font-size: 18px;
  margin-top: 5px;
  font-family: Karma;
  color: black;
`;

interface StoryHeaderProps {
  story: ApiStory;
}

const StoryHeader: FC<StoryHeaderProps> = ({ story }: StoryHeaderProps) => {
  const title = () => ApiStory.title(story);
  const authorName = () => ApiStory.authorFullName(story);
  const authorSlug = () => ApiAuthor.slug(ApiStory.author(story));
  const date = () => Time.dateWrittenOut(ApiStory.publicationDate(story));
  const multipleAuthors = () => ApiStory.multipleAuthors(story);
  const summary = () => ApiStory.summary(story);

  return (
    <HeaderContainer>
      <StoryTitle noLink={true} storySlug={null}>
        {title()}
      </StoryTitle>
      <Summary>{summary()}</Summary>
      {multipleAuthors().length > 1 ? (
        <StoryAuthorsName multipleAuthors={multipleAuthors()} />
      ) : (
        <StoryAuthorName authorSlug={authorSlug()} connector="">
          {authorName()}
        </StoryAuthorName>
      )}
      <StoryDate>{date()}</StoryDate>
    </HeaderContainer>
  );
};

export default StoryHeader;
